import React, { Component } from "react";
import { Spin } from "antd";
import { showErrorNotification, strings } from "../../../helpers";
import AnalyticsView from "./AnalyticsView";

import { getAnalytics } from "../../../services";

export default class AnalyticsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newsTagsList: [],
      isProcessing: false,
      totalRecords: 0,
      totalPage: 0,
      pageNo: 1,
      sortBy: "",
      sortOrder: "asc"
    };
  }

  componentDidMount() {
    this.fetchAnalytics();
  }

  /**
   * @function fetchDoctorsList
   * @description This function get doctors data
   */
  fetchAnalytics = () => {
    const { pageNo, sortOrder, sortBy } = this.state;
    this.setState({
      isProcessing: true
    });
    getAnalytics(pageNo, sortOrder, sortBy)
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response && response.data && response.data.success) {
          const { news_tags, total_records, total_pages } = response.data.data;
          this.setState({
            newsTagsList: news_tags,
            totalRecords: total_records,
            totalPages: total_pages
          });
        } else {
          this.setState({
            newsTagsList: [],
            totalRecords: 0,
            totalPages: 0
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ newsTagsList: [], isProcessing: false });
      });
  };

  /**
   * @function onPageChange
   * @oaram page
   * @description This function get called on page change
   */
  onPageChange = page => {
    this.setState({ pageNo: page, newsTagsList: [] }, () => {
      this.fetchAnalytics();
    });
  };

  /**
   * @function handleTableChange
   * @description This function handles sorting of anayltics data
   */
  handleTableChange = (pagination, filters, sorter) => {
    const { columnKey, order } = sorter;
    let sortOrder = "asc";
    if (order == "descend") sortOrder = "desc";
    this.setState(
      { sortOrder, sortBy: columnKey, pageNo: 1, newsTagsList: [] },
      () => {
        this.fetchAnalytics();
      }
    );
  };

  render() {
    const {
      newsTagsList,
      isProcessing,
      totalRecords,
      totalPages,
      pageNo
    } = this.state;
    return (
      <Spin spinning={isProcessing}>
        <AnalyticsView
          newsTagsList={newsTagsList}
          allRecords={totalRecords}
          allPages={totalPages}
          pageNo={pageNo}
          onPageChange={this.onPageChange}
          handleTableChange={this.handleTableChange}
        />
      </Spin>
    );
  }
}
